export default __webpack_public_path__ + "static/media/placeholder_business08-jp-web.5ab88856.png";